import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { updateFundingEnquiryStatus } from './types';

import {
  requestUpdateFundingEnquiryStatusSuccess,
  requestUpdateFundingEnquiryStatusFailure,
} from './reducer';

const logger = new Logger('Saga:FundingEnquiryUpdateStatus');

export function* requestUpdateFundingEnquiryStatusSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { id, status } = action;

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.platform.enquiry_update_status', { id }),
      { status },
    );

    yield put(requestUpdateFundingEnquiryStatusSuccess(response.data));
    action.promise && action.promise.resolve();
  } catch (error) {
    logger.error('Failed to request updating enquiry status with the following error', error);
    yield put(requestUpdateFundingEnquiryStatusFailure(error));
    action.promise && action.promise.reject();
  }
}

export default function* fundingEnquiryUpdateStatusSaga() {
  return yield all([
    takeLatest(updateFundingEnquiryStatus.request, requestUpdateFundingEnquiryStatusSaga),
  ]);
}
